import React, { Component } from "react";
import parse from "html-react-parser";
import "./style.scss";
import ThermocyclerCover from "./img/Thermocycler steps.svg";
import close from "../../../img/close.svg"

export class Poster extends Component {

  finishStep = () => {
    switch (this.props.type) {
      case "MASTERMIX_POSTER":
        this.masterMixViewed();
        break;
      case "THERMOCYCLER_POSTER":
        this.thermocyclerViewed();
        break;
      default:
      // code block
    }
  };

  getTitle = () => {

    let title;

    switch (this.props.type) {
      case "MASTERMIX_POSTER":
        title = "Master mix poster";
        break;
      case "THERMOCYCLER_POSTER":
        title = "Thermocycler poster";
        break;
      default:
      // code block
    }

    return title;
  };

  getSubTitle = () => {

    let title;

    switch (this.props.type) {
      case "MASTERMIX_POSTER":
        title = "Master mix";
        break;
      case "THERMOCYCLER_POSTER":
        title = "Thermocycler steps";
        break;
      default:
      // code block
    }

    return title;
  };

  masterMixViewed = () => {
    this.props.masterMixViewed(true);
    this.props.showModal({
      display: false,
    });
  };

  thermocyclerViewed = () => {
    this.props.thermocyclerViewed(true);
    this.props.showModal({
      display: false,
    });
  };

  buildCards = (items) => {

    return (
      <div style={{
        display: "flex",
        flexDirection: "row"
      }}>
        {items[this.props.levelSelected.label].map((item)=>(
          <div style={{
            background: "white",
            borderRadius: "5px",
            margin: "2px",
            flexBasis: ((100 / items[this.props.levelSelected.label].length) + "%"),
            padding: "8px"
          }}>
            <h5 style={{marginTop: 0, marginBottom: "8px"}}>{item.heading}</h5>
            <p>{parse(item.text)}</p>
          </div>
        ))}
      </div>
    );
  }

  getBackground = (style, type) => {

    let background;

    switch (style) {
      case "Grey":
        if(type === "Heading"){
          background = "rgba(204, 216, 225, 1)"
        } else {
          background = "white"
        }
        break;
      case "Blue":
        if(type === "Heading"){
          background = "rgba(102, 206, 245, 1)"
        } else {
          background = "rgba(204, 239, 252, 1)"
        }
        break;
      case "Yellow":
        if(type === "Heading"){
          background = "rgba(250, 172, 72, 1)"
        } else {
          background = "rgba(254, 238, 218, 1)"
        }
        break;
      case "Green":
        if(type === "Heading"){
          background = "rgba(157, 203, 128, 1)"
        } else {
          background = "rgba(230, 242, 223, 1)"
        }
        break;
      default:
      // code block
    }

    return background;
  }

  buildTable = (items) => {

    return (
      <div style={{
        marginBottom: "16px", borderRadius: "5px", overflow: "hidden"
      }}>
      <table>
        {items[this.props.levelSelected.label].map((row)=>(
          <tr>
            {row.map((item)=>(
              <td style={{
                background: this.getBackground(item.Style, item.Type),
              }}>
                {(item.Type === "Heading" || item.Type === "Text")?(
                  <p style={{fontWeight: (item.Type === "Heading")?"bold":null}}>{parse(item.Content)}</p>
                ):(
                  <div style={{textAlign: "left"}}>
                    {parse(item.Content)}
                  </div>
                )}
              </td>
            ))}
          </tr>
        ))}
      </table>
      </div>
    );
  }

  render() {

    return (
      <>
      <div
        aria-label="Close Button"
        tabIndex={0}
        className="close"
        onKeyDown={e => {
          if (e.keyCode === 13 || e.keyCode === 32) this.finishStep(e);
        }}
        onClick={()=>this.finishStep()}
      >
        <p>
          Close{" "}
          <img
            style={{
              display: "inline-block",
              top: "3px",
              position: "relative"
            }}
            src={close}
            alt="Close button"
          />
        </p>
      </div>
      <div className="modal-section poster"
      style={{
        width: "calc(100% - 0px)",
        margin: "auto",
      }}
      >
        <div className="modal-header">
          <h2>{this.getTitle()}</h2>
        </div>
        <div className="modal-body">
          <h3 style={{color: "white"}}>{this.getSubTitle()}</h3>
          {(this.props.type === "THERMOCYCLER_POSTER")?(
            <div className="cover-image" style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginBottom: "16px"
            }}>
              {<img src={ThermocyclerCover} alt="Thermocycler steps." />}
            </div>
          ):null}
          {this.buildTable(
            (this.props.type === "MASTERMIX_POSTER")?{
              "Level one":
              [
                [
                  {
                    "Type": "Heading",
                    "Content": "Ingredients",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Amount needed for 1 reaction",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Master mix: Amount needed for 5 reactions",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "DNase-free water",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "19.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "97.5 μl",
                    "Style": "Yellow"
                  }
                ],

                [
                  {
                    "Type": "Text",
                    "Content": "10X buffer",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "12.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "Forward primer",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "Reverse primer",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "dNTPs",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "<i>Taq</i> DNA polymerase",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Total",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "24.0 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Heading",
                    "Content": "120.0 μl",
                    "Style": "Yellow"
                  }
                ]
              ],
              "Level two":
              [
                [
                  {
                    "Type": "Heading",
                    "Content": "Ingredients",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Amount needed for 1 reaction",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Master mix: Amount needed for 5 reactions",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "DNase-free water",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "19.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "97.5 μl",
                    "Style": "Yellow"
                  }
                ],

                [
                  {
                    "Type": "Text",
                    "Content": "10X buffer",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "12.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "Forward primer",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "Reverse primer",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "dNTPs",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Text",
                    "Content": "<i>Taq</i> DNA polymerase",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Text",
                    "Content": "0.5 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Text",
                    "Content": "2.5 μl",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Total",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "24.0 μl",
                    "Style": "Blue"
                  },
                  {
                    "Type": "Heading",
                    "Content": "120.0 μl",
                    "Style": "Yellow"
                  }
                ]
              ]
            }:{
              "Level one":
              [
                [
                  {
                    "Type": "Heading",
                    "Content": "Step",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Temperature",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Duration",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Initial denaturation",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>94°C</b></br></br>This step may help to denature your template initially, and enable the PCR to occur more efficiently.</p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>5 minutes</b></br></br>The time and temperature of this step can vary depending on the template DNA and the salt concentrations of the buffer. A longer incubation time with higher temperatures may be necessary for genomic DNA, and for DNA with a *GC content greater than 65%. Buffers with higher salt concentrations may also warrant higher temperatures.</br></br>* ‘GC content’ stands for ‘guanine-cytosine content’ and is the percentage of nitrogenous bases in a DNA or RNA molecule that are either a guanine (G) or a cytosine (C).</p>",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "(A) Denaturing",
                    "Style": "Yellow"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>94°C</b></br></br>At this temperature, the double-stranded sample DNA is separated (denatured) into single strands.</p>",
                    "Style": "Yellow"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>30 seconds</b></p>",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "(B) Annealing",
                    "Style": "Blue"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>64°C</b></br></br>This is the optimal annealing temperature for the primers and template DNA used in this experiment. At this temperature, the primers can bind to the single strands of the template DNA. Annealing temperatures are typically 50°C to 70°C, and set to no more than 5°C below the lower of the primers' melting points.  The exact temperature depends on the primers you are using, particularly their length and GC content, and the salt concentration of the buffer.</p>",
                    "Style": "Blue"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>30 seconds</b></p>",
                    "Style": "Blue"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "(C) Elongation (or extension)",
                    "Style": "Green"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>72°C</b></br></br>This is the optimal temperature for <i>Taq</i> DNA polymerase to function. In this step, the polymerase creates a new strand of DNA, starting at the 3' end of each primer.</p>",
                    "Style": "Green"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>30 seconds</b></br></br>The general rule is 1 minute for every 1,000 bp being elongated. In this experiment, the region being amplified is 2400 bp long, so we should use a 30-second elongation step.</p>",
                    "Style": "Green"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Number of cycles",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p></p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>35 cycles</b></br></br>Fewer than 20 cycles may not result in enough PCR product to be visible. More than 45 cycles is not recommended, as nonspecific bands appear.</p>",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Final elongation (or extension)",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>72°C</b></br></br>This allows the final round of primer elongation by <i>Taq</i> DNA polymerase to come to completion.</p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>1 minute</b></p>",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Final hold temperature",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>4°C</b></br></br>This allows samples to remain at refrigeration temperature in the machine until they are removed.</p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>Infinity</b></p>",
                    "Style": "Grey"
                  }
                ]
              ],
              "Level two":
              [
                [
                  {
                    "Type": "Heading",
                    "Content": "Step",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Title",
                    "Style": "Grey"
                  },
                  {
                    "Type": "Heading",
                    "Content": "Duration",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Initial denaturation step",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>95°C</b></br></br>This optional step may help to denature your template initially, and enable the PCR to occur more efficiently.</p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>Typically 1 to 3 minutes</b></br></br>The time and temperature of this step can vary depending on the nature of the template DNA and the salt concentrations of the buffer. Longer incubations with higher temperatures may be necessary for genomic DNA (as opposed to plasmid DNA), and for DNA with a GC content greater than 65%. Buffers with higher salt concentrations may also warrant higher temperatures.</p>",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "(A) Denaturing",
                    "Style": "Yellow"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>95°C</b></br></br>At this temperature, the double-stranded sample DNA is separated (denatured) into single strands.</p>",
                    "Style": "Yellow"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>30 seconds</b></p>",
                    "Style": "Yellow"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "(B) Annealing",
                    "Style": "Blue"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>Annealing temperatures are typically 50°C to 70°C, set to no more than 5°C below the lower of the primers' melting points.</b><br><br><i>In this experiment, you could have chosen 4 primer pairs (A-D):</i><br><br>A. Primer 1 (20 nucleotides, 60% GC content, Tm= 61°C):<br>5’-GGCTGTGTTTGCGTCTCTCC-3’<br>and<br>Primer 8 (19 nucleotides, 58% GC content, Tm= 59°C):<br>5’-GAACCCCGATTATGACGGC-3’<br><br>B. Primer 2 (20 nucleotides, 60% GC content, Tm= 61°C):<br>5’-GGAGAGACGCAAACACAGCC-3’<br>and<br>Primer 7 (19 nucleotides, 58% GC content, Tm= 59°C):<br>5’-GCCGTCATAATCGGGGTTC-3’<br><br>C. Primer 3 (17 nucleotides, 41% GC content, Tm= 47°C):<br>5’-TACAGTCAGTATCAAGC-3’<br>and<br>Primer 6 (17 nucleotides, 41% GC content, Tm= 47°C):<br>5’-AATTGATACTGACTGGG-3’<br><br>D. Primer 4 (17 nucleotides, 41% GC content, Tm= 47°C):<br>(5’-GCTTGATACTGACTGTA-3’)<br>and<br>Primer 5 (17 nucleotides, 41% GC content, Tm= 47°C): 5’-CCCAGTCAGTATCAATT-3’</p>",
                    "Style": "Blue"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>30 seconds</b></p>",
                    "Style": "Blue"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "(C) Elongation",
                    "Style": "Green"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>72°C</b></br></br>This is the optimal temperature for <i>Taq</i> DNA polymerase to function. In this step, the polymerase creates a new strand of DNA, starting at the 3' end of each primer.</p>",
                    "Style": "Green"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>1 minute for every 1,000 bp being elongated</b></br></br>In this experiment, the region you are trying to amplify is either 700 bp or 1,000 bp long, so we should use a 60-second elongation step.</p>",
                    "Style": "Green"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Number of cycles",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>Typically 25 to 35 cycles for an amplifying PCR experiment</b></p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>In this experiment, we will do 25 cycles.</b></br></br>More than 45 cycles is not recommended, as nonspecific bands appear with higher numbers of cycles. Fewer than 20 cycles may not result in enough PCR product to be visible.</p>",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Final elongation step",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>72°C</b></br></br>This allows the final round of primer elongation by <i>Taq</i> DNA polymerase to come to completion.</p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>5 minute final elongation step</b></p>",
                    "Style": "Grey"
                  }
                ],
                [
                  {
                    "Type": "Heading",
                    "Content": "Final hold temperature",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>4°C</b></br></br>This allows for samples to remain at refrigeration temperature in the machine until they are removed.</p>",
                    "Style": "Grey"
                  },
                  {
                    "Type": "HTML",
                    "Content": "<p><b>Infinity</b></p>",
                    "Style": "Grey"
                  }
                ]
              ]
            }
          )}
          {(this.props.type === "MASTERMIX_POSTER")?
            this.buildCards({
            "Level one":
            [
              {
                "heading": "Master mix",
                "text": "<p>When having to set up multiple reactions that have nearly the same ingredients, setting up a master mix can save time and minimize tedious pipetting.</p><p>A master mix includes all the ingredients that all the reactions have in common, but it does not include any reagent that makes each reaction unique.</p>",
              },
              {
                "heading": "Excluding the template",
                "text": "<p>Each of our reactions includes water, buffer, dNTPs, <i>Taq</i> DNA polymerase, and the same forward and reverse primers, so these can all be included in the master mix. Each reaction has a different template, however, so we cannot include the template in our master mix.</p><p>After making our master mix, we can transfer 24 μl to 4 different tubes, and then add 1 μl of a different template to each tube to bring each reaction up to the final volume of 25 μl.</p>",
              },
              {
                "heading": "Quantity",
                "text": "In our example, we are running 4 PCR reactions (3 controls and 1 sample), so we could make a master mix recipe by multiplying the volume for each reagent by 4. However, to be on the safe side, it helps to make a bit extra, so we will make enough master mix for 5 PCR reactions. To do so, we will multiply the volume needed for each reagent by 5."
              }
            ],
            "Level two":
            [
              {
                "heading": "Master mix",
                "text": "<p>When having to set up multiple reactions that have nearly the same ingredients, setting up a master mix can save time and minimize tedious pipetting.</p><p>A master mix includes all the ingredients that all the reactions have in common, but it does not include any reagent that makes each reaction unique.</p>",
              },
              {
                "heading": "Excluding the template",
                "text": "<p>Each of our reactions includes water, buffer, dNTPs, <i>Taq</i> DNA polymerase, and the same forward and reverse primers, so these can all be included in the master mix. Each reaction has a different template, however, so we cannot include the template in our master mix.</p><p>After making our master mix, we can transfer 24 μl to 4 different tubes, and then add 1 μl of a different template to each tube to bring each reaction up to the final volume of 25 μl.</p>",
              },
              {
                "heading": "Quantity",
                "text": "In our example, we are running 4 PCR reactions (3 controls and 1 sample), so we could make a master mix recipe by multiplying the volume for each reagent by 4. However, to be on the safe side, it helps to make a bit extra, so we will make enough master mix for 5 PCR reactions. To do so, we will multiply the volume needed for each reagent by 5."
              }
            ]
          })
          :null}
        </div>
        <div className="modal-footer">
          <div
            style={{
              justifySelf: "flex-start",
              marginRight: "auto",
            }}
          >
            <p>
              Hit the "Next" button when you want to move on.
            </p>
          </div>
          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={() => this.finishStep()}
          >
            Next
          </button>
        </div>
      </div>
      </>
    );
  }
}
